import {getMocked} from './getMocked';
import {noop} from '../functions/noop';
import {Controller, FriendlyController} from '../../../controllers/Controller';
import {AnyFn} from '../../types/common/functions/AnyFn';
import {AnyIndex} from '../../types/common/index/AnyIndex';
import {ObservableFlag} from '../../types/rxjs/ObservableFlag';

export function getMockedController<T extends Controller>(
    mockedValues?: Partial<T>,
    defaultMockFactory?: AnyFn<[AnyIndex]>
): T {
    const cp = Controller.prototype;
    const fcp = Controller.prototype as unknown as FriendlyController;

    const extendedMocks: any = mockedValues ?? {};

    extendedMocks.priority ??= 0;
    extendedMocks.init ??= noop();
    extendedMocks.getBusyFlag ??= () => new ObservableFlag();

    extendedMocks.getUseStateHook ??= cp.getUseStateHook;
    extendedMocks.useState ??= cp.useState;
    extendedMocks.getStateSubject ??= fcp.getStateSubject;

    return getMocked<T>(extendedMocks, defaultMockFactory);
}